import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Button, TextField, Box, Divider, Typography } from "@material-ui/core";

/* eslint-disable */
const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/* eslint-enable */

// ⭐ REPARATUR: Direktes Entpacken der Props (inklusive Fallbacks für die Refresh-Funktion)
function MdlSettingCreateAccount({ createUser, onClose, getUsersData, onRefresh, props }) {
	const { t } = useTranslation();
	const [errorMsg, setErrorMsg] = useState("");
	const [disabled, setDisabled] = useState(true);

	const [requestData, setRequestData] = useState({
		username: "",
		first_name: "",
		last_name: "",
		phone: "",
		language: "de",
		role: 1,
		is_active: true,	  
		email: "",
		password: "",
		confirmPassword: "",
		lastFocus: 0,
	});

	const handleChange = (event) => {
	  const { name, value } = event.target;

	  // Typen-Konvertierung für Booleans und Nummern, damit Go es im Struct versteht
	  let parsedValue = value;
	  
	  if (name === "is_active") {
		parsedValue = value === "true" || value === true;
	  } else if (name === "role") {
		parsedValue = parseInt(value, 10);
		if (isNaN(parsedValue)) parsedValue = 0; // Fallback für ungültige Eingaben
	  }

	  setRequestData({
		...requestData,
		[name]: parsedValue,
		lastFocus: name,
	  });
	};
  
  useEffect(() => {
    const isEmailValid = re.test(requestData.email);
    const hasUsername = requestData.username.trim() !== "";
    const hasPassword = requestData.password.length >= 4;
    const passwordsMatch = requestData.password === requestData.confirmPassword;

    setDisabled(!(isEmailValid && hasUsername && hasPassword && passwordsMatch));
  }, [requestData.email, requestData.username, requestData.password, requestData.confirmPassword]);

  const sendRequest = () => {
	setErrorMsg(""); // ⭐ 1. Fehlermeldung vor dem Versuch leeren
    // ⭐ REPARATUR: Wartet, bis der Redux-Request durch ist, bevor geschlossen/aktualisiert wird
    Promise.resolve(createUser(requestData))
      .then(() => {
        // Erkennt automatisch, ob die Prop 'getUsersData' oder 'onRefresh' übergeben wurde
        if (getUsersData) getUsersData();
        if (onRefresh) onRefresh();
        
        onClose(); 
      })
      .catch((err) => {
        console.error("Fehler beim Erstellen:", err);
        setErrorMsg(t("MdlSettingCreateAccount.statusMsg_sendCreateRequest")); 
      });	  
  };
  
  return (
    <Box style={{ width: "100%", maxWidth: "460px", height: "90%", maxHeight: "600px", display: "flex", overflowY: "auto", flexDirection: "column", margin: "0 auto", boxSizing: "border-box", paddingRight: "4px" }} >
      {errorMsg && <Typography color="error" variant="body2" sx={{ mb: 2 }}>{errorMsg}</Typography>}

      <form noValidate autoComplete="off" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        
        {/* Sektion 1: Login-Daten */}
        <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
			  {t("MdlSettingCreateAccount.subtitle_section_1")}
          </Typography>
          
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            error={!re.test(requestData.email) && requestData.email !== "" && requestData.lastFocus !== "email"}
            type="email"
            label={t("user.email")}
            name="email"
            value={requestData.email}
            onChange={handleChange}
            helperText={!re.test(requestData.email) && requestData.email && requestData.lastFocus !== "email" ? "Ungültige E-Mail-Adresse" : ""}
          />
          
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="password"
            label={t("user.password")}
            name="password"
            autoComplete="new-password"
            value={requestData.password}
            onChange={handleChange}
          />
          
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            error={requestData.password !== requestData.confirmPassword && requestData.confirmPassword !== ""}
            type="password"
            label={t("MdlSettingCreateAccount.password_confirm")}
            name="confirmPassword"
            autoComplete="new-password"
            value={requestData.confirmPassword}
            onChange={handleChange}
            helperText={requestData.password !== requestData.confirmPassword && requestData.confirmPassword !== "" ? t("MdlSettingCreateAccount.statusMsg_confirmPassword") : ""}
          />
        </Box>

        <Divider style={{ margin: "5px 0" }} />

        {/* Sektion 2: Personendaten */}
        <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
			  {t("MdlSettingCreateAccount.subtitle_section_2")}
          </Typography>

          <TextField fullWidth variant="outlined" size="small" label={t("user.username")} name="username" value={requestData.username} onChange={handleChange} />
          <TextField fullWidth variant="outlined" size="small" label={t("user.givenname")} name="first_name" value={requestData.first_name} onChange={handleChange} />
          <TextField fullWidth variant="outlined" size="small" label={t("user.lastname")} name="last_name" value={requestData.last_name} onChange={handleChange} />
          <TextField fullWidth variant="outlined" size="small" label={t("user.phone")} name="phone" value={requestData.phone} onChange={handleChange} />
          	  
		  <TextField
			select fullWidth variant="outlined" size="small"
			label={t("user.language")} name="language"
			value={requestData.language} onChange={handleChange}
			SelectProps={{ native: true }} // Gewährleistet vertikales Aufklappen
		  >
			<option value="de">{t("common.langOptionDe")}</option>
			<option value="en">{t("common.langOptionEn")}</option>
		  </TextField>		  
		  
        </Box>
		
		
        <Divider style={{ margin: "5px 0" }} />

        {/* Sektion 2: Personendaten */}
        <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
			  {t("MdlSettingCreateAccount.subtitle_section_3")}
          </Typography>


        {/* Nativer Select-Einschub: Garantiert saubere vertikale Listenordnung */}
        <TextField
          select
          fullWidth
          variant="outlined"
          size="small"
          label={t("user.activity")}
          name="is_active"
          value={requestData.is_active.toString()}
          onChange={handleChange}
          SelectProps={{ native: true }}
        >
          <option value="true">{t("user.is_active_true")}</option>
          <option value="false">{t("user.is_active_false")}</option>
        </TextField>

        <TextField
          select
          fullWidth
          variant="outlined"
          size="small"
          label={t("user.role")}
          name="role"
          value={requestData.role.toString()}
          onChange={handleChange}
          SelectProps={{ native: true }}
        >
          <option value="0">0 ({t("user.role_admin")})</option>
          <option value="1">1 ({t("user.role_user")})</option>
        </TextField>
        </Box>


        <Divider sx={{ my: 0.5 }} />		
		

        {/* Button-Aktionsbereich */}
        <Box style={{ marginTop: "10px", display: "flex", justifyContent: "space-between", gap: "12px" }}>
          <Button 
            variant="outlined" 
            onClick={onClose}
            style={{ borderRadius: "8px", padding: "10px 20px", textTransform: "none" }}
          >
				{t("common.cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={disabled}
            onClick={sendRequest}
            style={{ 
              borderRadius: "8px", 
              padding: "10px 25px", 
              backgroundColor: disabled ? "rgba(0,0,0,0.12)" : "#4f40b3",
              color: disabled ? "rgba(0,0,0,0.26)" : "white",
              textTransform: "none",
              boxShadow: "0 4px 12px rgba(79, 64, 179, 0.25)"
            }}
          >
			{t("common.save")}
          </Button>
        </Box>

      </form>
    </Box>
  );
}

export default MdlSettingCreateAccount;
